import { Button, Flex } from "@/atoms"

import styles from "./NotificationTemplate.module.scss"

import type { NotificationTemplateProps } from "./open-pr.types"

export const NotificationTemplate = (props: NotificationTemplateProps) => {
  const { children, icon, buttonText, text, buttonProps } = props

  return (
    <Flex vertical gap={16}>
      <div className={styles.grid}>
        <span className={styles.icon}>{icon}</span>
        <span>{text}</span>
        {children && (
          <>
            <span />
            <Flex vertical>{children}</Flex>
          </>
        )}
      </div>
      {buttonText && (
        <Flex flex={1} justify="flex-end">
          <Button size="small" className={styles.button} {...buttonProps}>
            {buttonText}
          </Button>
        </Flex>
      )}
    </Flex>
  )
}
